import { ErrorCode } from '@primer-io/checkout-web'

/**
 * Buy providers methods names
 */
export const enum methodsNames {
    primer = 'primer',
}

/**
 * Buy providers names
 */
export const enum providersNames {
    banxa = 'Banxa',
    moonpay = 'Moonpay',
    mercuryo = 'Mercuryo',
    xanpool = 'Xanpool',
    simplex = 'Simplex',
    fiat2crypto = 'Fiat2crypto',
}

/**
 * Primer errors that wont show primer error notification
 */
export const showFailedScreenPrimerErrors = [
    ErrorCode.CARD_NUMBER_ERROR,
    ErrorCode.PAYMENT_CREATION_ABORTED,
    ErrorCode.PAYMENT_FAILED,
    ErrorCode.PAYMENT_METHOD_NOT_COMPATIBLE,
    ErrorCode.TAX_ERROR,
    ErrorCode.THREE_DS_AUTH_FAILED,
    ErrorCode.THREE_DS_NEGOTIATION_ERROR,
    ErrorCode.THREE_DS_SETUP_ERROR,
]

export enum View {
    Buy,
    Primer,
    TxInfo,
}

/** Hardcoded map of known not-user-friendly methods name  */
export const methodNameMap = {
    bank: 'Bank transfer',
    'Bank Transfer': 'Bank transfer',
    card: 'Debit/credit card',
    'Visa/Mastercard': 'Credit card',
    'Credit Card': 'Credit card',
    credit_debit_card: 'Debit/credit card',
    'duit-now': 'DuitNow',
    fps: 'FPS (Faster Payment System)',
    gbp_bank_transfer: 'GBP bank transfer',
    'hk-bank-transfer': 'HK bank transfer',
    'id-bank-transfer': 'ID bank transfer',
    'in-bank-transfer': 'IN bank transfer',
    'Instant Bank Transfer': 'Instant bank transfer',
    instapay: 'InstaPay',
    Newsagent: 'Newsagent payment',
    'nz-bank-transfer': 'NZ bank transfer',
    'pay-id': 'PayID',
    paynow: 'PayNow',
    primer: 'Multiple payment methods',
    'prompt-pay': 'PromptPay',
    mercuryo: 'Multiple payment methods',
    sepa_bank_transfer: 'SEPA Bank transfer',
    SEPA: 'SEPA Bank transfer',
    'Simplex Account': 'Simplex account',
    'Turkish Bank Transfer': 'Turkish bank transfer',
    'viettel-pay': 'Viettel Pay',
    'Wallet Payment': 'Wallet payment',
    'Wire Transfer': 'Wire transfer',
}
